import script from "./StepDuration.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepDuration.vue?vue&type=script&setup=true&lang=ts"

import "./StepDuration.vue?vue&type=style&index=0&id=0bdfaa15&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bdfaa15"]])

export default __exports__